import { getCustomElement } from "../elements/index.js";
import { isHastElement } from "../types.js";
function buildChildAttributes(params) {
  const { node, filterTagName } = params;
  if (!node) return [];
  const children = node?.children || [];
  const attrsOfChildren = children.filter((child) => {
    if (!isHastElement(child)) return false;
    return filterTagName ? child.tagName === filterTagName : true;
  }).map((child) => {
    const customElement = getCustomElement(child.tagName);
    if (!customElement) return child.properties || {};
    return customElement.attributeTransform("", child.properties, child) || {};
  }).filter((attr) => attr !== null);
  return attrsOfChildren;
}
export {
  buildChildAttributes
};
//# sourceMappingURL=build-child-attributes.js.map
